"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7207],{

/***/ 44267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CardContent_CardContent; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(27192);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(28979);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(76087);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardContent/cardContentClasses.js

function getCardContentUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCardContent', slot);
}
const cardContentClasses = (0,generateUtilityClasses/* default */.Z)('MuiCardContent', ['root']);
/* harmony default export */ var CardContent_cardContentClasses = ((/* unused pure expression or super */ null && (cardContentClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardContent/CardContent.js


const _excluded = ["className", "component"];









const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardContentUtilityClass, classes);
};

const CardContentRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardContent',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  };
});
const CardContent = /*#__PURE__*/react.forwardRef(function CardContent(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCardContent'
  });

  const {
    className,
    component = 'div'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardContentRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var CardContent_CardContent = (CardContent);

/***/ }),

/***/ 27286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CardAds; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44267);
/* harmony import */ var _GoogleAds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28075);
// @mui


// components

function CardAds() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GoogleAds__WEBPACK_IMPORTED_MODULE_1__/* .GoogleBannerAds */ .D, {})
        })
    });
}


/***/ }),

/***/ 28075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ GoogleBannerAds; },
/* harmony export */   "a": function() { return /* binding */ GoogleGridAds; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function GoogleBannerAds() {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (err) {
            console.log(err);
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
        className: "adsbygoogle",
        style: {
            display: "block"
        },
        "data-ad-client": "ca-pub-2522844423315072",
        "data-ad-slot": "1281160371",
        "data-ad-format": "auto",
        "data-full-width-responsive": "true"
    });
}
function GoogleGridAds() {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (err) {
            console.log(err);
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
        className: "adsbygoogle",
        style: {
            display: "block"
        },
        "data-ad-format": "autorelaxed",
        "data-ad-client": "ca-pub-2522844423315072",
        "data-ad-slot": "6470023398"
    });
}


/***/ }),

/***/ 90519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50122);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15861);
/* harmony import */ var _utils_getFontValue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84856);






// @mui

// utils

// ----------------------------------------------------------------------
var TextMaxLine = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var asLink = _param.asLink, _variant = _param.variant, variant = _variant === void 0 ? "body1" : _variant, _line = _param.line, line = _line === void 0 ? 2 : _line, _persistent = _param.persistent, persistent = _persistent === void 0 ? false : _persistent, children = _param.children, sx = _param.sx, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "asLink",
        "variant",
        "line",
        "persistent",
        "children",
        "sx"
    ]);
    var lineHeight = (0,_utils_getFontValue__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(variant).lineHeight;
    var style = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: line,
        WebkitBoxOrient: "vertical"
    }, persistent && {
        height: lineHeight * line
    }, sx);
    if (asLink) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            color: "inherit",
            ref: ref,
            variant: variant,
            sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, style)
        }, other), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        variant: variant,
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, style)
    }, other), {
        children: children
    }));
});
TextMaxLine.propTypes = {
    asLink: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().node.isRequired),
    line: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().number),
    persistent: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),
    sx: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().object),
    variant: prop_types__WEBPACK_IMPORTED_MODULE_8___default().oneOf([
        "body1",
        "body2",
        "button",
        "caption",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "inherit",
        "overline",
        "subtitle1",
        "subtitle2", 
    ])
};
/* harmony default export */ __webpack_exports__["Z"] = (TextMaxLine);


/***/ }),

/***/ 94920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i5": function() { return /* reexport */ CarouselArrows; },
  "A0": function() { return /* reexport */ CarouselDots; }
});

// UNUSED EXPORTS: CarouselArrowIndex

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
;// CONCATENATED MODULE: ./src/components/carousel/CarouselDots.js
// @mui





// ----------------------------------------------------------------------
var RootStyle = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "rounded";
    }
})(function(param) {
    var rounded = param.rounded;
    return {
        display: "flex",
        listStyle: "none",
        alignItems: "center",
        justifyContent: "center",
        "& li": {
            width: 18,
            height: 18,
            opacity: 0.32,
            cursor: "pointer"
        },
        "& li.slick-active": (0,_object_spread/* default */.Z)({
            opacity: 1
        }, rounded && {
            "& .dotActive": {
                width: 16,
                borderRadius: 6
            }
        })
    };
});
var DotWrapStyle = (0,styled/* default */.ZP)("div")(function() {
    return {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    };
});
var DotStyle = (0,styled/* default */.ZP)("span")(function(param) {
    var theme = param.theme;
    return {
        width: 8,
        height: 8,
        borderRadius: "50%",
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.short
        })
    };
});
// ----------------------------------------------------------------------
function CarouselDots(props) {
    var color = props === null || props === void 0 ? void 0 : props.color;
    var rounded = (props === null || props === void 0 ? void 0 : props.rounded) || false;
    return {
        appendDots: function(dots) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RootStyle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    rounded: rounded,
                    component: "ul"
                }, props), {
                    children: dots
                }))
            });
        },
        customPaging: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DotWrapStyle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DotStyle, {
                    className: "dotActive",
                    sx: {
                        bgcolor: color || "primary.main"
                    }
                })
            });
        }
    };
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./src/components/Iconify.js
var Iconify = __webpack_require__(22554);
// EXTERNAL MODULE: ./src/components/animate/index.js + 14 modules
var animate = __webpack_require__(59636);
;// CONCATENATED MODULE: ./src/components/carousel/CarouselArrows.js





// @mui


//


// ----------------------------------------------------------------------
var BUTTON_SIZE = 40;
var ArrowStyle = (0,styled/* default */.ZP)(animate/* IconButtonAnimate */.w_, {
    shouldForwardProp: function(prop) {
        return prop !== "filled";
    }
})(function(param) {
    var filled = param.filled, theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        width: BUTTON_SIZE,
        height: BUTTON_SIZE,
        cursor: "pointer",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            color: theme.palette.text.primary
        }
    }, filled && {
        opacity: 0.48,
        borderRadius: Number(theme.shape.borderRadius) * 1.5,
        color: theme.palette.common.white,
        backgroundColor: theme.palette.grey[900],
        "&:hover": {
            opacity: 1,
            color: theme.palette.common.white,
            backgroundColor: theme.palette.grey[900]
        }
    });
});
// ----------------------------------------------------------------------
CarouselArrows.propTypes = {
    children: (prop_types_default()).node,
    customIcon: prop_types_default().oneOfType([
        (prop_types_default()).element,
        (prop_types_default()).string
    ]),
    filled: (prop_types_default()).bool,
    onNext: (prop_types_default()).func,
    onPrevious: (prop_types_default()).func
};
function CarouselArrows(_param) {
    var _filled = _param.filled, filled = _filled === void 0 ? false : _filled, customIcon = _param.customIcon, onNext = _param.onNext, onPrevious = _param.onPrevious, children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "filled",
        "customIcon",
        "onNext",
        "onPrevious",
        "children"
    ]);
    var theme = (0,useTheme/* default */.Z)();
    var isRTL = theme.direction === "rtl";
    var style = {
        position: "absolute",
        mt: -2.5,
        top: "50%",
        zIndex: 9
    };
    if (children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: "arrow left",
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                        left: 0
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowStyle, {
                        filled: filled,
                        onClick: onPrevious,
                        children: leftIcon(customIcon, isRTL)
                    })
                }),
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: "arrow right",
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                        right: 0
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowStyle, {
                        filled: filled,
                        onClick: onNext,
                        children: rightIcon(customIcon, isRTL)
                    })
                })
            ]
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        direction: "row",
        spacing: 1
    }, other), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowStyle, {
                className: "arrow left",
                filled: filled,
                onClick: onPrevious,
                children: leftIcon(customIcon, isRTL)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowStyle, {
                className: "arrow right",
                filled: filled,
                onClick: onNext,
                children: rightIcon(customIcon, isRTL)
            })
        ]
    }));
}
// ----------------------------------------------------------------------
var leftIcon = function(customIcon, isRTL) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
        icon: customIcon ? customIcon : "eva:arrow-right-fill",
        sx: (0,_object_spread/* default */.Z)({
            width: 20,
            height: 20,
            transform: " scaleX(-1)"
        }, isRTL && {
            transform: " scaleX(1)"
        })
    });
};
var rightIcon = function(customIcon, isRTL) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
        icon: customIcon ? customIcon : "eva:arrow-right-fill",
        sx: (0,_object_spread/* default */.Z)({
            width: 20,
            height: 20
        }, isRTL && {
            transform: " scaleX(-1)"
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
;// CONCATENATED MODULE: ./src/components/carousel/CarouselArrowIndex.js





// @mui


//

// ----------------------------------------------------------------------
var CarouselArrowIndex_RootStyle = (0,styled/* default */.ZP)(Box/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        zIndex: 9,
        display: "flex",
        alignItems: "center",
        position: "absolute",
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        color: theme.palette.common.white,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.grey[900], 0.48)
    };
});
var CarouselArrowIndex_ArrowStyle = (0,styled/* default */.ZP)(IconButton/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        padding: 6,
        opacity: 0.48,
        color: theme.palette.common.white,
        "&:hover": {
            opacity: 1
        }
    };
});
// ----------------------------------------------------------------------
CarouselArrowIndex.propTypes = {
    customIcon: prop_types_default().oneOfType([
        (prop_types_default()).element,
        (prop_types_default()).string
    ]),
    index: (prop_types_default()).number,
    onNext: (prop_types_default()).func,
    onPrevious: (prop_types_default()).func,
    total: (prop_types_default()).number
};
function CarouselArrowIndex(_param) {
    var index = _param.index, total = _param.total, onNext = _param.onNext, onPrevious = _param.onPrevious, customIcon = _param.customIcon, other = (0,_object_without_properties/* default */.Z)(_param, [
        "index",
        "total",
        "onNext",
        "onPrevious",
        "customIcon"
    ]);
    var theme = (0,useTheme/* default */.Z)();
    var isRTL = theme.direction === "rtl";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CarouselArrowIndex_RootStyle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselArrowIndex_ArrowStyle, {
                size: "small",
                onClick: onPrevious,
                children: CarouselArrowIndex_leftIcon(customIcon, isRTL)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "subtitle2",
                children: [
                    index + 1,
                    "/",
                    total
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselArrowIndex_ArrowStyle, {
                size: "small",
                onClick: onNext,
                children: CarouselArrowIndex_rightIcon(customIcon, isRTL)
            })
        ]
    }));
}
// ----------------------------------------------------------------------
var CarouselArrowIndex_leftIcon = function(customIcon, isRTL) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
        icon: customIcon ? customIcon : "eva:arrow-right-fill",
        sx: (0,_object_spread/* default */.Z)({
            width: 20,
            height: 20,
            transform: " scaleX(-1)"
        }, isRTL && {
            transform: " scaleX(1)"
        })
    });
};
var CarouselArrowIndex_rightIcon = function(customIcon, isRTL) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
        icon: customIcon ? customIcon : "eva:arrow-right-fill",
        sx: (0,_object_spread/* default */.Z)({
            width: 20,
            height: 20
        }, isRTL && {
            transform: " scaleX(-1)"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/carousel/index.js





/***/ }),

/***/ 52584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HomeCar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 23 modules
var motion_minimal = __webpack_require__(45962);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(27948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(87952);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./src/redux/store.js + 10 modules
var store = __webpack_require__(33599);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/assets/licenseDetails.json
var licenseDetails = __webpack_require__(71798);
// EXTERNAL MODULE: ./src/assets/reviewTopicMap.json
var reviewTopicMap = __webpack_require__(80706);
// EXTERNAL MODULE: ./src/components/CardAds.js
var CardAds = __webpack_require__(27286);
// EXTERNAL MODULE: ./src/components/Image.js
var Image = __webpack_require__(65907);
// EXTERNAL MODULE: ./src/components/animate/index.js + 14 modules
var animate = __webpack_require__(59636);
// EXTERNAL MODULE: ./src/hooks/useSettings.js
var useSettings = __webpack_require__(40571);
// EXTERNAL MODULE: ./src/layouts/index.js + 21 modules
var layouts = __webpack_require__(85307);
// EXTERNAL MODULE: ./src/utils/mapLicense.js + 6 modules
var mapLicense = __webpack_require__(31553);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 5 modules
var TextField = __webpack_require__(13362);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(18972);
// EXTERNAL MODULE: ./src/hooks/useLocales.js + 5 modules
var useLocales = __webpack_require__(9671);
// EXTERNAL MODULE: ./src/redux/slices/gplx.quiz.js
var gplx_quiz = __webpack_require__(44326);
;// CONCATENATED MODULE: ./src/sections/exam/Exam600Header.js
/* eslint-disable react-hooks/exhaustive-deps */ 










function Exam600Header() {
    var translate = (0,useLocales/* default */.Z)().translate;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        component: animate/* MotionViewport */.DG,
        sx: {
            mb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
            variants: (0,animate/* varFade */.EU)().inDown,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "h2",
                        textAlign: "center",
                        textTransform: "capitalize",
                        children: [
                            translate("car.title"),
                            " ",
                            new Date().getMonth() + 1,
                            "/",
                            new Date().getFullYear()
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectSmall, {})
                ]
            })
        })
    });
}
function SelectSmall() {
    var checkLicenseIndex = function checkLicenseIndex(licenseIndex) {
        if (licenseIndex < 4) {
            return 4;
        } else {
            return licenseIndex;
        }
    };
    var dispatch = (0,store/* useDispatch */.I0)();
    var licenseIndex = (0,store/* useSelector */.v9)(function(state) {
        return state.exam;
    }).licenseIndex;
    var ref = (0,react.useState)(checkLicenseIndex(licenseIndex)), license = ref[0], setLicense = ref[1];
    var handleChange = function(event) {
        var licenseDetail = licenseDetails[event.target.value];
        setLicense(event.target.value);
        dispatch((0,gplx_quiz/* setLicenseData */.xr)({
            licenseIndex: event.target.value,
            licenseName: licenseDetail.name,
            licenseRequirement: {
                time: licenseDetail.time,
                correctAnswers: licenseDetail.correctAnswers
            },
            totalExams: licenseDetail.totalExams
        }));
    };
    (0,react.useEffect)(function() {
        var licenseDetail = licenseDetails[license];
        dispatch((0,gplx_quiz/* setLicenseData */.xr)({
            licenseIndex: license,
            licenseName: licenseDetail.name,
            licenseRequirement: {
                time: licenseDetail.time,
                correctAnswers: licenseDetail.correctAnswers
            },
            totalExams: licenseDetail.totalExams
        }));
        setLicense(license);
    }, [
        license
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        alignItems: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            my: 1,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                size: "medium",
                sx: {
                    minWidth: 200
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextField/* default */.Z, {
                    variant: "outlined",
                    select: true,
                    size: "medium",
                    onChange: handleChange,
                    value: license,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                            value: 4,
                            children: "Hạng _ B1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                            value: 5,
                            children: "Hạng _ B2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                            value: 6,
                            children: "Hạng _ C"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                            value: 7,
                            children: "Hạng _ D"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                            value: 8,
                            children: "Hạng _ E"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                            value: 9,
                            children: "Hạng _ F"
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./src/sections/practicalExam/LicenseTypeItem.js
var LicenseTypeItem = __webpack_require__(76332);
// EXTERNAL MODULE: ./src/sections/situation/SituationHeader.js
var SituationHeader = __webpack_require__(55486);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./src/components/carousel/index.js + 3 modules
var carousel = __webpack_require__(94920);
;// CONCATENATED MODULE: ./src/sections/gplx/CarSlider.js





// @mui


// components


// ----------------------------------------------------------------------
var data = [
    {
        id: 2,
        image: "/slider/lo-trinh-hoc-xe-oto.jpg"
    }
];
var OverlayStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 8,
        position: "absolute",
        backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.grey[500], 0.1)
    };
});
// ----------------------------------------------------------------------
function CarSlider() {
    var settings = (0,_object_spread/* default */.Z)({
        speed: 1000,
        dots: true,
        arrows: false,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1
    }, (0,carousel/* CarouselDots */.A0)({
        position: "absolute",
        right: 24,
        bottom: 24
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
            children: data.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselItem, {
                    item: item
                }, item.id);
            })
        }))
    });
}
// ----------------------------------------------------------------------
CarouselItem.propTypes = {
    item: prop_types_default().shape({
        image: (prop_types_default()).string,
        name: (prop_types_default()).string
    })
};
function CarouselItem(param) {
    var item = param.item;
    var image = item.image, name = item.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayStyle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                alt: name,
                src: image,
                ratio: "16/8"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/gplx/HomeCar.js
/* eslint-disable react/prop-types */ 




// @mui



// hooks














var HomeCar_data = [
    "A1",
    "A2",
    "A3",
    "A4",
    "B1",
    "B2",
    "C",
    "D",
    "E",
    "F"
];
HomeCar.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* default */.Z, {
        variant: "main",
        children: page
    });
};
// ----------------------------------------------------------------------
var RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(10)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(15),
        paddingBottom: theme.spacing(15)
    });
});
var Item = (0,styled/* default */.ZP)(Card/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        backgroundColor: theme.palette.background.neutral
    }, theme.typography.body2), {
        padding: theme.spacing(1),
        textAlign: "center",
        color: theme.palette.text.primary,
        paddingBottom: 30,
        "&:hover": {
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px"
        },
        cursor: "pointer"
    });
});
var Header = (0,styled/* default */.ZP)(Box/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 70,
        borderRadius: 25,
        padding: 5
    }, theme.typography.body1), {
        color: "#fff"
    });
});
// ----------------------------------------------------------------------
function HomeCar(param) {
    var licenseTypes = param.licenseTypes;
    var checkLicenseIndexSupprise = function checkLicenseIndexSupprise(licenseIndex) {
        if (licenseIndex > 4) {
            return (0,mapLicense/* topic */.cC)(reviewTopicMap[4][1].indexes);
        } else {
            return (0,mapLicense/* topic */.cC)(reviewTopicMap[licenseIndex][1].indexes);
        }
    };
    var checkLicenseIndexArray = function checkLicenseIndexArray(licenseIndex) {
        if (licenseIndex > 4) {
            return reviewTopicMap[4][0].indexes;
        } else {
            return reviewTopicMap[licenseIndex][0].indexes;
        }
    };
    var themeStretch = (0,useSettings/* default */.Z)().themeStretch;
    var ref = (0,store/* useSelector */.v9)(function(state) {
        return state.exam;
    }), totalExams = ref.totalExams, licenseName = ref.licenseName, licenseIndex = ref.licenseIndex, licenseResultOfUser = ref.licenseResultOfUser, licenseWrongQuestions = ref.licenseWrongQuestions;
    var ref1 = (0,react.useState)(checkLicenseIndexSupprise(licenseIndex)), surprise = ref1[0], setSupprise = ref1[1];
    var ref2 = (0,react.useState)(checkLicenseIndexArray(licenseIndex)), array = ref2[0], setArray = ref2[1];
    var wrongQuestions = licenseWrongQuestions === null || licenseWrongQuestions === void 0 ? void 0 : licenseWrongQuestions[licenseIndex].reduce(function(partialSum, e) {
        return partialSum + e.length;
    }, 0);
    (0,react.useEffect)(function() {
        if (licenseIndex > 4) {
            setSupprise((0,mapLicense/* topic */.cC)(reviewTopicMap[4][1].indexes));
            setArray(reviewTopicMap[4][0].indexes);
        } else {
            setSupprise((0,mapLicense/* topic */.cC)(reviewTopicMap[licenseIndex][1].indexes));
            setArray(reviewTopicMap[licenseIndex][0].indexes);
        }
    }, [
        licenseIndex
    ]);
    var item = licenseDetails.find(function(item) {
        return item.name === licenseName;
    });
    var totalDone = licenseResultOfUser[licenseIndex].reduce(function(partialSum, e) {
        return partialSum + (e === null ? 1 : 0);
    }, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: themeStretch ? "xl" : "lg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootStyle, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Exam600Header, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    component: animate/* MotionViewport */.DG,
                    sx: {
                        mb: 5
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                md: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                    variants: (0,animate/* varFade */.EU)().inLeft,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/thi-gplx/o-to/hang-bang-".concat(licenseName.toLowerCase(), "/thi-thu-de-ngau-nhien"),
                                        style: {
                                            textDecoration: "none"
                                        },
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                                    sx: {
                                                        backgroundColor: "#19b389"
                                                    },
                                                    children: HomeCar_data[licenseIndex]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: {
                                                        display: "flex",
                                                        justifyContent: "center"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        alt: "Thi thử ngẫu nhi\xean",
                                                        src: "/icons/car.png",
                                                        sx: {
                                                            height: 50,
                                                            width: 50,
                                                            mb: 1
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "h6",
                                                    children: "Thi thử ngẫu nhi\xean"
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                md: 4,
                                lg: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                    variants: (0,animate/* varFade */.EU)().inDown,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/thi-gplx/o-to/hang-bang-".concat(licenseName.toLowerCase(), "/thi-thu-de-tao-san"),
                                        style: {
                                            textDecoration: "none"
                                        },
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                                                    sx: {
                                                        backgroundColor: "#0a90a3"
                                                    },
                                                    children: [
                                                        totalExams - totalDone,
                                                        "/",
                                                        item.totalExams
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: {
                                                        display: "flex",
                                                        justifyContent: "center"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        alt: "Thi thử đề tạo sẵn",
                                                        src: "/icons/choose.png",
                                                        sx: {
                                                            height: 50,
                                                            width: 50,
                                                            mb: 1
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "h6",
                                                    children: "Thi thử đề tạo sẵn"
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                md: 4,
                                lg: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                    variants: (0,animate/* varFade */.EU)().inRight,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/thi-gplx/o-to/hang-bang-".concat(licenseName.toLowerCase(), "/on-tap"),
                                        style: {
                                            textDecoration: "none"
                                        },
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                                    sx: {
                                                        backgroundColor: "#3f87dbd9"
                                                    },
                                                    children: array.length
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: {
                                                        display: "flex",
                                                        justifyContent: "center"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        alt: "\xd4n tập to\xe0n bộ c\xe2u hỏi",
                                                        src: "/icons/quiz.png",
                                                        sx: {
                                                            height: 50,
                                                            width: 50,
                                                            mb: 1
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "h6",
                                                    children: "\xd4n tập to\xe0n bộ c\xe2u hỏi"
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                md: 4,
                                lg: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                    variants: (0,animate/* varFade */.EU)().inLeft,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/thi-gplx/o-to/hang-bang-".concat(licenseName.toLowerCase(), "/cau-diem-liet"),
                                        style: {
                                            textDecoration: "none"
                                        },
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                                    sx: {
                                                        backgroundColor: "#ff5b00"
                                                    },
                                                    children: surprise.length
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: {
                                                        display: "flex",
                                                        justifyContent: "center"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        alt: "\xd4n tập c\xe2u điểm liệt",
                                                        src: "/icons/wrong.png",
                                                        sx: {
                                                            height: 50,
                                                            width: 50,
                                                            mb: 1
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "h6",
                                                    children: "\xd4n tập c\xe2u điểm liệt"
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                md: 4,
                                lg: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                    variants: (0,animate/* varFade */.EU)().inDown,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/thi-gplx/o-to/hang-bang-".concat(licenseName.toLowerCase(), "/top-cau-sai"),
                                        style: {
                                            textDecoration: "none"
                                        },
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                                                    sx: {
                                                        backgroundColor: "#d13c3c"
                                                    },
                                                    children: [
                                                        wrongQuestions,
                                                        "_50"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: {
                                                        display: "flex",
                                                        justifyContent: "center"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        alt: "C\xe2u hỏi l\xe0m sai",
                                                        src: "/icons/answer.png",
                                                        sx: {
                                                            height: 50,
                                                            width: 50,
                                                            mb: 1
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "h6",
                                                    children: "C\xe2u hỏi l\xe0m sai"
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                md: 4,
                                lg: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                    variants: (0,animate/* varFade */.EU)().inRight,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/thi-gplx/bien-bao",
                                        style: {
                                            textDecoration: "none"
                                        },
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                                    sx: {
                                                        backgroundColor: "#e7bd00"
                                                    },
                                                    children: "6"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: {
                                                        display: "flex",
                                                        justifyContent: "center"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        alt: "Biển b\xe1o giao th\xf4ng",
                                                        src: "/icons/traffic-light.png",
                                                        sx: {
                                                            height: 50,
                                                            width: 50,
                                                            mb: 1
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "h6",
                                                    children: "Biển b\xe1o giao th\xf4ng"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                            sx: {
                                my: 5,
                                height: 0
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                            variants: (0,animate/* varFade */.EU)().inDown,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h2",
                                textAlign: "center",
                                textTransform: "capitalize",
                                children: "120 M\xf4 Phỏng v2.0.0 (2024)"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SituationHeader/* SituationHeader */.C, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        sx: {
                            my: 5,
                            height: 0
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Practice, {
                    licenseTypes: licenseTypes
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        sx: {
                            my: 5,
                            height: 0
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Street, {
                    licenseTypes: licenseTypes
                })
            ]
        })
    });
}
function BannerSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: 3,
        mb: 6,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarSlider, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardAds/* default */.Z, {})
            })
        ]
    });
}
function Practice(param) {
    var licenseTypes = param.licenseTypes;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        component: animate/* MotionViewport */.DG,
        sx: {
            mb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                variants: (0,animate/* varFade */.EU)().inDown,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h2",
                    textAlign: "center",
                    textTransform: "capitalize",
                    children: "B\xe0i thi sa h\xecnh \xf4 t\xf4 đạt 100 điểm"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                spacing: 2,
                mt: 3,
                children: licenseTypes.filter(function(i) {
                    return i.orderNo > 2;
                }).map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LicenseTypeItem/* default */.Z, {
                            item: item
                        })
                    }, item.id);
                })
            })
        ]
    });
}
function Street(param) {
    var licenseTypes = param.licenseTypes;
    var streetExams = [];
    licenseTypes.forEach(function(license) {
        var ref;
        streetExams = streetExams.concat((ref = license.practicalExams) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
            return item.type === 1;
        }));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        component: animate/* MotionViewport */.DG,
        sx: {
            mb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                variants: (0,animate/* varFade */.EU)().inDown,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h2",
                    textAlign: "center",
                    textTransform: "capitalize",
                    children: "B\xe0i thi đường trường hạng B, C, D, E, F"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                spacing: 2,
                mt: 3,
                children: streetExams.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StreetItem, {
                            item: item
                        })
                    }, item.id);
                })
            })
        ]
    });
}
function StreetItem(param) {
    var item = param.item;
    var urlify = function urlify(text) {
        var anchors = /<img\s[^>]*?src=(["']?)([^\s]+?)\1[^>]*?>/ig;
        var links = [];
        text.replace(anchors, function(_anchor, _quote, url) {
            links.push(url);
        });
        return links === null || links === void 0 ? void 0 : links[0];
    };
    var title = item.title, slug = item.slug, description = item.description;
    var imagePath = urlify(description);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/thi-duong-truong/".concat(slug),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            color: "inherit",
            underline: "none",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    spacing: 2.5,
                    py: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 2,
                        px: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                variant: "rounded",
                                alt: "",
                                sx: {
                                    bgcolor: "#FFE7D9",
                                    color: "#333",
                                    fontWeight: 600
                                },
                                children: title.substring(title.length - 2).trim()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle1",
                                textTransform: "capitalize",
                                children: title
                            })
                        ]
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 74445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HomeBike; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 23 modules
var motion_minimal = __webpack_require__(45962);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(27948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/redux/store.js + 10 modules
var store = __webpack_require__(33599);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/assets/licenseDetails.json
var licenseDetails = __webpack_require__(71798);
// EXTERNAL MODULE: ./src/assets/reviewTopicMap.json
var reviewTopicMap = __webpack_require__(80706);
// EXTERNAL MODULE: ./src/components/CardAds.js
var CardAds = __webpack_require__(27286);
// EXTERNAL MODULE: ./src/components/Image.js
var Image = __webpack_require__(65907);
// EXTERNAL MODULE: ./src/components/animate/index.js + 14 modules
var animate = __webpack_require__(59636);
// EXTERNAL MODULE: ./src/hooks/useSettings.js
var useSettings = __webpack_require__(40571);
// EXTERNAL MODULE: ./src/layouts/index.js + 21 modules
var layouts = __webpack_require__(85307);
// EXTERNAL MODULE: ./src/utils/mapLicense.js + 6 modules
var mapLicense = __webpack_require__(31553);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 5 modules
var TextField = __webpack_require__(13362);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(18972);
// EXTERNAL MODULE: ./src/hooks/useLocales.js + 5 modules
var useLocales = __webpack_require__(9671);
// EXTERNAL MODULE: ./src/redux/slices/gplx.quiz.js
var gplx_quiz = __webpack_require__(44326);
;// CONCATENATED MODULE: ./src/sections/exam/Exam200Header.js
/* eslint-disable react-hooks/exhaustive-deps */ 










function Exam200Header() {
    var translate = (0,useLocales/* default */.Z)().translate;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        component: animate/* MotionViewport */.DG,
        sx: {
            mb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
            variants: (0,animate/* varFade */.EU)().inDown,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "h2",
                        textAlign: "center",
                        textTransform: "capitalize",
                        children: [
                            translate("bike.title"),
                            " ",
                            new Date().getMonth() + 1,
                            "/",
                            new Date().getFullYear()
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectSmall, {})
                ]
            })
        })
    });
}
function SelectSmall() {
    var checkLicenseIndex = function checkLicenseIndex(licenseIndex) {
        if (licenseIndex >= 4) {
            return 0;
        } else {
            return licenseIndex;
        }
    };
    var dispatch = (0,store/* useDispatch */.I0)();
    var licenseIndex = (0,store/* useSelector */.v9)(function(state) {
        return state.exam;
    }).licenseIndex;
    var ref = (0,react.useState)(checkLicenseIndex(licenseIndex)), license = ref[0], setLicense = ref[1];
    (0,react.useEffect)(function() {
        var licenseDetail = licenseDetails[license];
        dispatch((0,gplx_quiz/* setLicenseData */.xr)({
            licenseIndex: license,
            licenseName: licenseDetail.name,
            licenseRequirement: {
                time: licenseDetail.time,
                correctAnswers: licenseDetail.correctAnswers
            },
            totalExams: licenseDetail.totalExams
        }));
        setLicense(license);
    }, [
        license
    ]);
    var handleChange = function(event) {
        var licenseDetail = licenseDetails[event.target.value];
        setLicense(event.target.value);
        dispatch((0,gplx_quiz/* setLicenseData */.xr)({
            licenseIndex: event.target.value,
            licenseName: licenseDetail.name,
            licenseRequirement: {
                time: licenseDetail.time,
                correctAnswers: licenseDetail.correctAnswers
            },
            totalExams: licenseDetail.totalExams
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        alignItems: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            my: 1,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                size: "medium",
                sx: {
                    minWidth: 200
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextField/* default */.Z, {
                    variant: "outlined",
                    select: true,
                    size: "medium",
                    onChange: handleChange,
                    value: license,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                            value: 0,
                            children: "Hạng _ A1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                            value: 1,
                            children: "Hạng _ A2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                            value: 2,
                            children: "Hạng _ A3"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                            value: 3,
                            children: "Hạng _ A4"
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./src/sections/practicalExam/LicenseTypeItem.js
var LicenseTypeItem = __webpack_require__(76332);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./src/components/carousel/index.js + 3 modules
var carousel = __webpack_require__(94920);
;// CONCATENATED MODULE: ./src/sections/gplx/MotorSlider.js





// @mui


// components


// ----------------------------------------------------------------------
var data = [
    {
        id: 2,
        image: "/slider/lo-trinh-hoc-xe-may.jpg"
    }
];
var OverlayStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 8,
        position: "absolute",
        backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.grey[500], 0.1)
    };
});
// ----------------------------------------------------------------------
function MotorSlider() {
    var settings = (0,_object_spread/* default */.Z)({
        speed: 1000,
        dots: true,
        arrows: false,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1
    }, (0,carousel/* CarouselDots */.A0)({
        position: "absolute",
        right: 24,
        bottom: 24
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
            children: data.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselItem, {
                    item: item
                }, item.id);
            })
        }))
    });
}
// ----------------------------------------------------------------------
CarouselItem.propTypes = {
    item: prop_types_default().shape({
        image: (prop_types_default()).string,
        name: (prop_types_default()).string
    })
};
function CarouselItem(param) {
    var item = param.item;
    var image = item.image, name = item.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayStyle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                alt: name,
                src: image,
                ratio: "16/8"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/gplx/HomeMotoBike.js
/* eslint-disable react/prop-types */ 




// @mui




// hooks












HomeBike.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* default */.Z, {
        variant: "main",
        children: page
    });
};
var HomeMotoBike_data = [
    "A1",
    "A2",
    "A3",
    "A4",
    "B1",
    "B2",
    "C",
    "D",
    "E",
    "F"
];
// ----------------------------------------------------------------------
var RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(10)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(15),
        paddingBottom: theme.spacing(15)
    });
});
var Item = (0,styled/* default */.ZP)(Card/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        backgroundColor: theme.palette.background.neutral
    }, theme.typography.body2), {
        padding: theme.spacing(1),
        textAlign: "center",
        color: theme.palette.text.primary,
        paddingBottom: 30,
        "&:hover": {
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px"
        },
        cursor: "pointer"
    });
});
var Header = (0,styled/* default */.ZP)(Box/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 70,
        borderRadius: 25,
        padding: 5
    }, theme.typography.body1), {
        color: "#fff"
    });
});
// ----------------------------------------------------------------------
function HomeBike(param) {
    var licenseTypes = param.licenseTypes;
    var checkLicenseIndexSupprise = function checkLicenseIndexSupprise(licenseIndex) {
        if (licenseIndex > 4) {
            return (0,mapLicense/* topic */.cC)(reviewTopicMap[4][1].indexes);
        } else {
            return (0,mapLicense/* topic */.cC)(reviewTopicMap[licenseIndex][1].indexes);
        }
    };
    var checkLicenseIndexArray = function checkLicenseIndexArray(licenseIndex) {
        if (licenseIndex > 4) {
            return reviewTopicMap[4][0].indexes;
        } else {
            return reviewTopicMap[licenseIndex][0].indexes;
        }
    };
    var themeStretch = (0,useSettings/* default */.Z)().themeStretch;
    var ref = (0,store/* useSelector */.v9)(function(state) {
        return state.exam;
    }), totalExams = ref.totalExams, licenseName = ref.licenseName, licenseIndex = ref.licenseIndex, licenseResultOfUser = ref.licenseResultOfUser, licenseWrongQuestions = ref.licenseWrongQuestions;
    var ref1 = (0,react.useState)(checkLicenseIndexSupprise(licenseIndex)), surprise = ref1[0], setSupprise = ref1[1];
    var ref2 = (0,react.useState)(checkLicenseIndexArray(licenseIndex)), array = ref2[0], setArray = ref2[1];
    var wrongQuestions = licenseWrongQuestions === null || licenseWrongQuestions === void 0 ? void 0 : licenseWrongQuestions[licenseIndex].reduce(function(partialSum, e) {
        return partialSum + e.length;
    }, 0);
    (0,react.useEffect)(function() {
        if (licenseIndex > 4) {
            setSupprise((0,mapLicense/* topic */.cC)(reviewTopicMap[4][1].indexes));
            setArray(reviewTopicMap[4][0].indexes);
        } else {
            setSupprise((0,mapLicense/* topic */.cC)(reviewTopicMap[licenseIndex][1].indexes));
            setArray(reviewTopicMap[licenseIndex][0].indexes);
        }
    }, [
        licenseIndex
    ]);
    var item = licenseDetails.find(function(item) {
        return item.name === licenseName;
    });
    var totalDone = licenseResultOfUser[licenseIndex].reduce(function(partialSum, e) {
        return partialSum + (e === null ? 1 : 0);
    }, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: themeStretch ? "xl" : "lg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootStyle, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Exam200Header, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    component: animate/* MotionViewport */.DG,
                    sx: {
                        mb: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            container: true,
                            spacing: 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    sm: 6,
                                    md: 4,
                                    lg: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                        variants: (0,animate/* varFade */.EU)().inLeft,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/thi-gplx/xe-may/hang-bang-".concat(licenseName.toLowerCase(), "/thi-thu-de-ngau-nhien"),
                                            style: {
                                                textDecoration: "none"
                                            },
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                                        sx: {
                                                            backgroundColor: "#3e67c3"
                                                        },
                                                        children: HomeMotoBike_data[licenseIndex]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        sx: {
                                                            display: "flex",
                                                            justifyContent: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            alt: "Thi thử ngẫu nhi\xean",
                                                            src: "/icons/motorcycle.png",
                                                            sx: {
                                                                height: 50,
                                                                width: 50,
                                                                mb: 1
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "h6",
                                                        children: "Thi thử ngẫu nhi\xean"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    sm: 6,
                                    md: 4,
                                    lg: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                        variants: (0,animate/* varFade */.EU)().inDown,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/thi-gplx/xe-may/hang-bang-".concat(licenseName.toLowerCase(), "/thi-thu-de-tao-san"),
                                            style: {
                                                textDecoration: "none"
                                            },
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                                                        sx: {
                                                            backgroundColor: "#069cd5"
                                                        },
                                                        children: [
                                                            " ",
                                                            totalExams - totalDone,
                                                            "/",
                                                            item.totalExams,
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        sx: {
                                                            display: "flex",
                                                            justifyContent: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            alt: "Thi thử đề tạo sẵn",
                                                            src: "/icons/answer-2.png",
                                                            sx: {
                                                                height: 50,
                                                                width: 50,
                                                                mb: 1
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "h6",
                                                        children: "Thi thử đề tạo sẵn"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    sm: 6,
                                    md: 4,
                                    lg: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                        variants: (0,animate/* varFade */.EU)().inRight,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/thi-gplx/xe-may/hang-bang-".concat(licenseName.toLowerCase(), "/on-tap"),
                                            style: {
                                                textDecoration: "none"
                                            },
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                                        sx: {
                                                            backgroundColor: "#1ab776"
                                                        },
                                                        children: array.length
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        sx: {
                                                            display: "flex",
                                                            justifyContent: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            alt: "\xd4n tập to\xe0n bộ c\xe2u hỏi",
                                                            src: "/icons/quiz-2.png",
                                                            sx: {
                                                                height: 50,
                                                                width: 50,
                                                                mb: 1
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "h6",
                                                        children: "\xd4n tập to\xe0n bộ c\xe2u hỏi"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    sm: 6,
                                    md: 4,
                                    lg: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                        variants: (0,animate/* varFade */.EU)().inLeft,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/thi-gplx/xe-may/hang-bang-".concat(licenseName.toLowerCase(), "/cau-diem-liet"),
                                            style: {
                                                textDecoration: "none"
                                            },
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                                        sx: {
                                                            backgroundColor: "#f18312"
                                                        },
                                                        children: surprise.length
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        sx: {
                                                            display: "flex",
                                                            justifyContent: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            alt: "\xd4n tập c\xe2u điểm liệt",
                                                            src: "/icons/wrong2.png",
                                                            sx: {
                                                                height: 50,
                                                                width: 50,
                                                                mb: 1
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "h6",
                                                        children: "\xd4n tập c\xe2u điểm liệt"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    sm: 6,
                                    md: 4,
                                    lg: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                        variants: (0,animate/* varFade */.EU)().inDown,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/thi-gplx/xe-may/hang-bang-".concat(licenseName.toLowerCase(), "/top-cau-sai"),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                                                        sx: {
                                                            backgroundColor: "#d13c3c"
                                                        },
                                                        children: [
                                                            wrongQuestions,
                                                            "_50"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        sx: {
                                                            display: "flex",
                                                            justifyContent: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            alt: "C\xe2u hỏi bị sai nhiều",
                                                            src: "/icons/choice.png",
                                                            sx: {
                                                                height: 50,
                                                                width: 50,
                                                                mb: 1
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "h6",
                                                        children: "C\xe2u hỏi l\xe0m sai"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    sm: 6,
                                    md: 4,
                                    lg: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                        variants: (0,animate/* varFade */.EU)().inRight,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/thi-gplx/bien-bao",
                                            style: {
                                                textDecoration: "none"
                                            },
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                                        sx: {
                                                            backgroundColor: "#e7bd00"
                                                        },
                                                        children: "6"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        sx: {
                                                            display: "flex",
                                                            justifyContent: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            alt: "Biển b\xe1o giao th\xf4ng",
                                                            src: "/icons/traffic-light2.png",
                                                            sx: {
                                                                height: 50,
                                                                width: 50,
                                                                mb: 1
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "h6",
                                                        children: "Biển b\xe1o giao th\xf4ng"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                            sx: {
                                my: 5,
                                height: 0
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Practice, {
                    licenseTypes: licenseTypes
                })
            ]
        })
    });
}
function BannerSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: 3,
        mb: 6,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MotorSlider, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardAds/* default */.Z, {})
            })
        ]
    });
}
function Practice(param) {
    var licenseTypes = param.licenseTypes;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        component: animate/* MotionViewport */.DG,
        sx: {
            mb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                variants: (0,animate/* varFade */.EU)().inDown,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h2",
                    textAlign: "center",
                    textTransform: "capitalize",
                    children: "B\xe0i thi sa h\xecnh xe m\xe1y đạt 100 điểm"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                spacing: 2,
                mt: 3,
                children: [
                    licenseTypes.filter(function(i) {
                        return i.orderNo <= 2;
                    }).map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            md: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LicenseTypeItem/* default */.Z, {
                                item: item
                            })
                        }, item.id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardAds/* default */.Z, {})
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 76332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LicenseTypeItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50122);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87952);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67720);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65907);
/* harmony import */ var _components_TextMaxLine__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90519);
/* eslint-disable react/prop-types */ 




function LicenseTypeItem(param) {
    var item = param.item;
    var urlify = function urlify(text) {
        var anchors = /<img\s[^>]*?src=(["']?)([^\s]+?)\1[^>]*?>/ig;
        var links = [];
        text.replace(anchors, function(_anchor, _quote, url) {
            links.push(url);
        });
        return links === null || links === void 0 ? void 0 : links[0];
    };
    var title = item.title, orderNo = item.orderNo, slug = item.slug, description = item.description, metaDescription = item.metaDescription;
    var imagePath = urlify(description);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/thi-sa-hinh/".concat(slug),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            color: "inherit",
            underline: "none",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    spacing: 2.5,
                    pb: 2,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            alt: "preview",
                            src: imagePath,
                            sx: {
                                height: 200
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            direction: "row",
                            alignItems: "center",
                            spacing: 2,
                            px: 1,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    alt: "".concat(orderNo),
                                    sx: {
                                        bgcolor: "#78a6ff",
                                        color: "#fff",
                                        fontWeight: 600
                                    },
                                    children: title.substring(title.length - 2).trim()
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    variant: "subtitle1",
                                    textTransform: "capitalize",
                                    children: title
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextMaxLine__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            variant: "body2",
                            line: 3,
                            persistent: true,
                            px: 1,
                            children: metaDescription
                        })
                    ]
                })
            })
        })
    });
}


/***/ }),

/***/ 55486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ SituationHeader; }
/* harmony export */ });
/* unused harmony export MenuDashboard */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11496);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45962);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);
/* harmony import */ var _components_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65907);
/* harmony import */ var _components_animate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59636);
/* eslint-disable react/prop-types */ 









var Item = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, theme.typography.body2), {
        backgroundColor: theme.palette.background.neutral,
        padding: theme.spacing(0),
        textAlign: "center",
        color: theme.palette.text.secondary,
        paddingBottom: 20,
        "&:hover": {
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px"
        },
        cursor: "pointer"
    });
});
var Header = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        width: 70,
        borderRadius: 25,
        padding: 5
    }, theme.typography.body1), {
        color: "#fff"
    });
});
function SituationHeader() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        component: _components_animate__WEBPACK_IMPORTED_MODULE_4__/* .MotionViewport */ .DG,
        sx: {
            my: 5
        },
        disableGutters: true,
        maxWidth: "xl",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_11__.m.div, {
            variants: (0,_components_animate__WEBPACK_IMPORTED_MODULE_4__/* .varFade */ .EU)().inDown,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MenuDashboard, {})
        })
    });
}
var MenuDashboard = function() {
    var answers = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.situation;
    }).answers;
    var exams = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.examS;
    }).exams;
    var failedSituations = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.failSituation;
    }).failedSituations;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
        container: true,
        spacing: 3,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                item: true,
                xs: 6,
                sm: 3,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/thi-tinh-huong/",
                    style: {
                        textDecoration: "none"
                    },
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Item, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Header, {
                                sx: {
                                    backgroundColor: "#12779b"
                                },
                                children: [
                                    answers === null || answers === void 0 ? void 0 : answers.length,
                                    "_120"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                sx: {
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    alt: "\xd4n tập",
                                    src: "/icons/augmented-reality.png",
                                    sx: {
                                        height: 50,
                                        width: 50,
                                        mb: 1
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                variant: "subtitle1",
                                children: "\xd4n tập c\xe2u hỏi"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                item: true,
                xs: 6,
                sm: 3,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/thi-gplx/thi-that/",
                    style: {
                        textDecoration: "none"
                    },
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Item, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Header, {
                                sx: {
                                    backgroundColor: "#0a255e"
                                },
                                children: "*"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                sx: {
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    alt: "C\xe2u l\xe0m sai",
                                    src: "/icons/quiz.png",
                                    sx: {
                                        height: 50,
                                        width: 50,
                                        mb: 1
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                variant: "subtitle1",
                                children: "Thi m\xf4 phỏng"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                item: true,
                xs: 6,
                sm: 3,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/thi-tinh-huong/thi-thu/",
                    style: {
                        textDecoration: "none"
                    },
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Item, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Header, {
                                sx: {
                                    backgroundColor: "#ed7a57"
                                },
                                children: [
                                    exams === null || exams === void 0 ? void 0 : exams.length,
                                    "_12"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                sx: {
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    alt: "Thi thử m\xf4 phỏng",
                                    src: "/icons/simulator.png",
                                    sx: {
                                        height: 50,
                                        width: 50,
                                        mb: 1
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                variant: "subtitle1",
                                children: "Thi MP k\xe8m gợi \xfd"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                item: true,
                xs: 6,
                sm: 3,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/thi-tinh-huong/cau-sai/",
                    style: {
                        textDecoration: "none"
                    },
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Item, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Header, {
                                sx: {
                                    backgroundColor: "#d73d62"
                                },
                                children: [
                                    failedSituations.length,
                                    "_50"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                sx: {
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    alt: "C\xe2u l\xe0m sai",
                                    src: "/icons/warning.png",
                                    sx: {
                                        height: 50,
                                        width: 50,
                                        mb: 1
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                variant: "subtitle1",
                                children: "C\xe2u l\xe0m sai"
                            })
                        ]
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 50168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ licenseDataArray; }
/* harmony export */ });
// exam
var b1 = Array.from(Array(20).keys());
var b2 = Array.from(Array(18).keys());
var c = Array.from(Array(15).keys());
var d = Array.from(Array(14).keys());
var e = Array.from(Array(14).keys());
var f = Array.from(Array(14).keys());
var a1 = Array.from(Array(8).keys());
var a2 = Array.from(Array(18).keys());
var a3 = Array.from(Array(20).keys());
var a4 = Array.from(Array(20).keys());
// chapter
var chapterB1 = Array.from(Array(9).keys());
var chapterB2 = Array.from(Array(9).keys());
var chapterC = Array.from(Array(9).keys());
var chapterD = Array.from(Array(9).keys());
var chapterE = Array.from(Array(9).keys());
var chapterF = Array.from(Array(9).keys());
var chapterA1 = Array.from(Array(7).keys());
var chapterA2 = Array.from(Array(8).keys());
var chapterA3 = Array.from(Array(7).keys());
var chapterA4 = Array.from(Array(8).keys());
// examRandom
var b1Random = Array.from(Array(20).keys());
var b2Random = Array.from(Array(18).keys());
var cRandom = Array.from(Array(15).keys());
var dRandom = Array.from(Array(14).keys());
var eRandom = Array.from(Array(14).keys());
var fRandom = Array.from(Array(14).keys());
var a1Random = Array.from(Array(8).keys());
var a2Random = Array.from(Array(18).keys());
var a3Random = Array.from(Array(20).keys());
var a4Random = Array.from(Array(20).keys());
var licenseDataArray = [
    [
        a1,
        a2,
        a3,
        a4,
        b1,
        b2,
        c,
        d,
        e,
        f
    ],
    [
        chapterA1,
        chapterA2,
        chapterA3,
        chapterA4,
        chapterB1,
        chapterB2,
        chapterC,
        chapterD,
        chapterE,
        chapterF
    ],
    [
        a1Random,
        a2Random,
        a3Random,
        a4Random,
        b1Random,
        b2Random,
        cRandom,
        dRandom,
        eRandom,
        fRandom
    ],
    [
        "a1",
        "a2",
        "a3",
        "a4",
        "b1",
        "b2",
        "c",
        "d",
        "e",
        "f"
    ],
    [
        "o-to",
        "xe-may"
    ]
];


/***/ })

}]);